import NewApiService from "@/utils/new.api.service";
export default {
  getOptions(context) {
    return new Promise(resolve => {
      NewApiService.get("xperience/options")
        .then(({ data }) => {
          resolve(data.xperience);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  saveOptions(context, model) {
    return new Promise(resolve => {
      NewApiService.put("xperience/options", model)
        .then(({ data }) => {
          resolve(data.xperience);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  getBays(context){
    return new Promise((resolve,reject) => {
      NewApiService.get("xperience/bays")
      .then(({data})=>{
        context.commit("set_bays", data);
        resolve(data);
      })
      .catch((errors) => {
        reject(errors)
      })
    })
  },
  sendCommandToBay(_context, params){
    return new Promise((resolve, reject) => {
      NewApiService.put("xperience/bays",params)
      .then(({data}) => {
        //context.commit("set_loading");
        resolve(data);
      })
      .catch((error) =>{ 
        reject(error)
      })
    })
  },
  refreshTrackman(){
    return new Promise((resolve, reject) => {
      NewApiService.get("xperience/bays/refresh")
      .then(({data}) => {
        resolve(data);
      })
      .catch((error) =>{ 
        reject(error)
      })
    })
  },
  desactivateBay(_context, params){
    return new Promise((resolve, reject) => {
      NewApiService.put("xperience/bays/"+params.bayId+"/desactivate", params)
      .then(({data}) => {
        resolve(data);
      })
      .catch((error) =>{ 
        reject(error)
      })
    })
  },
};
